import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    error: {
      color: theme.red500,
      display: "block",
      fontSize: 14,
      marginBottom: theme.spacing(8),
      marginTop: theme.spacing(5),
      "& + &": {
        marginTop: 0,
      },
    },
    marginZero: {
      margin: 0,
    },
    errorWrapper: {
      marginBottom: theme.spacing(8),
      display: "flex",
    },
    dragDropInput: {
      alignItems: "center",
      background: theme.gray50,
      border: `1px solid ${theme.gray100}`,
      borderRadius: theme.spacing(2),
      color: theme.gray500,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      padding: theme.spacing(20, 10),
      textAlign: "center",
    },
    dragDropFiles: {
      alignItems: "center",
      justifyContent: "space-between",
      background: theme.white00,
      borderRadius: theme.spacing(2),
      display: "flex",
      flexDirection: "row",
      width: "143px",
      minWidth: "143px",
      height: "143px",
      position: "relative",
    },
    removeIcon: {
      cursor: "pointer",
      position: "absolute",
      top: "-12px",
      right: "-12px",
    },
    dragDropHeader: {
      fontSize: 15,
      fontWeight: 500,
      lineHeight: theme.spacing(13),
      textTransform: "uppercase",
      margin: theme.spacing(8, 0),
      color: theme.gray800,
    },

    dragDropFilesWrapper: {
      display: "flex",
      alignSelf: "start",
      flexDirection: "row",
      flexWrap: "nowrap",
      overflow: "hidden",
      marginTop: theme.spacing(0),
      gap: theme.spacing(16),
      padding: theme.spacing(8, 0),
      overflowX: "auto",
    },
    thumb: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },
    fileName: {
      cursor: "pointer",
      marginLeft: theme.spacing(8),
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      maxWidth: "260px",
    },
    shorterFileName: {
      maxWidth: "230px",
    },
    errorIcon: {
      color: theme.red500,
      margin: theme.spacing(0, 6),
      height: "28px",
      width: "28px",
    },
    scrollButtons: {
      alignItems: "center",
      display: "flex",
      opacity: 1,
      position: "absolute",
      height: "100%",
      width: "133px",
      zIndex: 1,

      "&:first-child": {
        justifyContent: "flex-start",
        left: "auto",
      },
      "&:last-child": {
        justifyContent: "flex-end",
        right: 0,
      },
      "& .MuiSvgIcon-root": {
        width: "32px",
        height: "32px",
        borderRadius: "50%",
        fill: theme.white50,
        backgroundColor: theme.primary500,
      },
    },
    tabs: {
      display: "flex",
      justifyContent: "space-between",
      gap: theme.spacing(8),
      position: "relative",
      alignItems: "center",
      width: "100%",
    },
    indicator: {
      "& .MuiTabs-indicator": {
        height: 0,
      },
    },
    item: {
      padding: 0,
      overflow: "visible",
    },
    flexContainer: {
      gap: theme.spacing(16),
      paddingTop: theme.spacing(8),
    },
    descPurple: {
      color: theme.primary500,
    },
    description: {
      marginBottom: theme.spacing(8),
      "& p": {
        display: "inline",
      },
    },
    supportedFiles: {
      fontSize: 14,
      color: theme.gray800,
    },
    hiddenInput: {
      top: 0,
      left: "-500px",
    },
  }),
);
